import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import PaymentGatwayDc from './PaymentGatwayDc'

function PaymentModal(props) {
    const { isPaymentModalOpen, setIsPaymentModalOpen, notify, isInScreen } = props
    const handleClose = () => {
        setIsPaymentModalOpen(false)
    }
    return (
        <>
            <Modal className='compmodal' show={isPaymentModalOpen} onHide={() => setIsPaymentModalOpen()} centered>
                <Modal.Header className='text-primary'><i className='fa fa-angle-left me-2 text-primary' onClick={() => handleClose()}></i><span className='w-100 text-center'>Add New Card</span></Modal.Header>
                <Modal.Body>
                    <PaymentGatwayDc setIsPaymentModalOpen={setIsPaymentModalOpen} notify={notify} isInScreen={isInScreen} />
                </Modal.Body>
            </Modal>
        </>
    )
}

PaymentModal.propTypes = {
    dispatch: PropTypes.func,
    isPaymentModalOpen: PropTypes.bool,
    setIsPaymentModalOpen: PropTypes.func,
    finalAction: PropTypes.func,
    notify: PropTypes.func,
    isInScreen: PropTypes.bool
}

PaymentModal.defaulProps = {
    dispatch: noop,
    isPaymentModalOpen: false,
    setIsPaymentModalOpen: noop,
    finalAction: noop,
    notify: noop,
    isInScreen: false
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(PaymentModal)